import { classes } from "lib/actions/util";
import { PropsWithChildren } from "react";
import ChevronRight from "components/icons/24/actions/chevron-right.svg";

export default function SpeckleBreadcrumbs(p: PropsWithChildren) {
  return (
    <div className="flex flex-wrap items-start gap-2 text-sm">{p.children}</div>
  );
}

export function SpeckleCrumb(
  p: PropsWithChildren<{
    active?: boolean;
    onClick?(): void;
  }>,
) {
  return (
    <button
      type="button"
      className={classes(
        "w-32 max-w-fit select-none truncate rounded-md py-1 outline-offset-4",
        p.active && "cursor-default bg-[#047efb] px-1.5 text-white",
      )}
      disabled={p.active}
      onClick={p.onClick}
    >
      {p.children}
    </button>
  );
}

export function SpeckleCrumbSeparator() {
  return <ChevronRight className="block w-5 py-1 text-icon-normal" />;
}
